import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProduct, IProductInitialState } from "./productModal";
import {
  ActiveInactiveProduct,
  createProduct,
  deleteProduct,
  FindAllCategoryWiseSubCategoryList,
  getAllActiveProduct,
  getAllProduct,
  getProductByID,
  ProductImageUpload,
  updateProduct,
} from "./services/product.services";

const initialState: IProductInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ProductID: null,
  ProductList: [],
  CategoriesList: [],
  ProductDetail: {
    ID: null,
    CategoryID: null,
    ProductName: "",
    ProductURL: "",
    Description: "",
    MetaName: "",
    MetaKeyword: "",
    MetaDescription: "",
    MainImage: "",
    IsActive: 1,
    ProductImageDetails: [],
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    clearProductDetails: (state) => {
      state.ProductDetail = initialState.ProductDetail;
    },
    setProductID: (state, action) => {
      state.ProductID = action.payload;
    },
    clearProductID: (state) => {
      state.ProductID = initialState.ProductID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllProduct.fulfilled,
      (state, action: PayloadAction<IProduct[]>) => {
        state.loading = false;
        state.ProductList = action.payload || [];
      }
    );
    builder.addCase(getAllProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProductList = [];
    });

    builder.addCase(FindAllCategoryWiseSubCategoryList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      FindAllCategoryWiseSubCategoryList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.CategoriesList = action.payload || [];
        state.error = "";
      }
    );
    builder.addCase(
      FindAllCategoryWiseSubCategoryList.rejected,
      (state, action) => {
        state.loading = false;
        state.CategoriesList = [];
        state.error = action.error.message || "Something went wrong";
      }
    );
    builder.addCase(createProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createProduct.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateProduct.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteProduct.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ProductImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ProductImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ProductImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getProductByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getProductByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ProductDetail = action.payload;
    });
    builder.addCase(getProductByID.rejected, (state, action) => {
      state.loading = false;
      state.ProductDetail = initialState.ProductDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveProduct.fulfilled,
      (state, action: PayloadAction<IProduct[]>) => {
        state.loading = false;
        state.ProductList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProductList = [];
    });
    builder.addCase(ActiveInactiveProduct.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveProduct.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveProduct.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearProductDetails, clearProductID, setProductID } =
  productSlice.actions;
export default productSlice.reducer;
